// extracted by mini-css-extract-plugin
export default {"image":"styles_image__zqL16","dragging":"styles_dragging__CVbbf","overlay":"styles_overlay__PtNl7"};